export default "__VITE_ASSET__KSKtlbzx__"